import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import type { ReporteProgrammatic } from '../types'

interface ProgrammaticCardProps {
  reporte: ReporteProgrammatic
}

export function ProgrammaticCard({ reporte }: ProgrammaticCardProps) {
  return (
    <Card className="border border-gray-300 dark:border-gray-700">
      <CardHeader className="pb-3">
        <CardTitle className="text-base">{reporte.nombre}</CardTitle>
      </CardHeader>
      <CardContent>
        <iframe
          src={reporte.url}
          className="w-full aspect-video rounded border-0"
          allowFullScreen
          sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
          title={reporte.nombre}
        />
      </CardContent>
    </Card>
  )
}
